<div class="bh-table" style="padding: 0 20px 15px">
    <div class="bh-table-title mat-subtitle-1"></div>
    <div class="content">Current blend fraction achieved the configuration for Binary Graph.Would you like to enable Binary Graph</div>
    <mat-dialog-actions align="end" >
        <button mat-button class="mat-button-sm cancel_btn" (click)="cancel()">No, Continue Save</button>
        <button mat-button class="mat-button-primary-sm" (click)="agree()">Yes</button>
    </mat-dialog-actions>
</div>
    